import 'zone.js/dist/zone';
import { NgModule } from 'angular-ts-decorators';

import { Session } from '@shared/app/scripts/services/session';
import { NotificationManager } from '@shared/app/scripts/services/notification-manager';
import { Language } from '@shared/app/scripts/services/language';
import { IsTest } from '@shared/app/scripts/services/is-test';
import { SwServiceWorker } from './services/service-worker';
import { TranslationsProvider } from './services/translations';
import {
  LanguageNames,
  ILanguageName,
} from '@shared/app/scripts/services/language-names';

require('../styles/softwear-bootstrap.scss');
require('../styles/module.scss');

require('@shared/app/scripts/app');

// TODO shared dependencies
require('angular-animate');
require('angular-route');
require('angular-messages');
require('angular-sanitize');
require('angular-translate');
require('angular-i18n/angular-locale_nl');
require('ngclipboard');

// TODO fix the issue the version replacement tried to fix
// TODO use original one after
// https://github.com/IamAdamJowett/angular-click-outside/pull/64/files is
// merged
require('@iamadamjowett/angular-click-outside');

require('ng-file-upload');
require('angular-ui-bootstrap');
require('ng-infinite-scroll');
require('checklist-model');
require('angular-loading-bar/build/loading-bar.min.css');
require('angular-loading-bar/build/loading-bar');
require('angular-tooltips/dist/angular-tooltips.min.css');
require('angular-tooltips/dist/angular-tooltips');
require('angular1-async-filter');
import 'ng-tags-input';
import 'ng-tags-input/build/ng-tags-input.css';

import { components } from './components';
import { classes } from './classes';
import { directives } from './directives';
import { filters } from './filters';
import { services } from './services';
import { vendor } from './vendor';

/**
 * Main module of the application. It is a place for all core, and backend
 * related services.
 */
@NgModule({
  id: 'coreModule',
  declarations: components.concat(directives, filters),
  providers: services.concat(vendor, classes),
  imports: [
    'ngSanitize',
    'ngRoute',
    'ngAnimate',
    'ngMessages',
    'ngFileUpload',
    'pascalprecht.translate',
    'angular-click-outside',
    'sharedModule',
    'ui.bootstrap',
    'infinite-scroll',
    'checklist-model',
    'angular-loading-bar',
    '720kb.tooltips',
    'asyncFilter',
    'ngclipboard',
    'ngTagsInput',
  ],
})
export class CoreModule {
  static config(
    $httpProvider: ng.IHttpProvider,
    $locationProvider,
    $qProvider,
    $routeProvider,
    $translateProvider,
    cfpLoadingBarProvider,
    isTest: IsTest,
    languageNames: LanguageNames,
    translationsProvider: TranslationsProvider,
  ) {
    'ngInject';

    $httpProvider.interceptors.push('withCredentialsInterceptor');

    cfpLoadingBarProvider.includeSpinner = false;

    // remove prefix to keep pre ng1.6 links working
    $locationProvider.hashPrefix('');

    // to avoid issues on the test side - otherwise route changes are fired
    // unexpectedly
    if (isTest) {
      $routeProvider.eagerInstantiationEnabled(false);
    }

    $routeProvider.when('/about', {
      template: '<about></about>',
    });

    // CORE-814 this prevents Possibly Unhandled Rejections from spamming Sentry
    $qProvider.errorOnUnhandledRejections(false);

    // supported i18n list
    translationsProvider.translations(
      'nl-nl',
      require('../translations/nl-nl.json'),
    );
    translationsProvider.translations(
      'en-gb',
      require('../translations/en-gb.json'),
    );
    translationsProvider.translations(
      'fr-fr',
      require('../translations/fr-fr.json'),
    );
    translationsProvider.translations(
      'de-de',
      require('../translations/de-de.json'),
    );
    translationsProvider.translations(
      'it-it',
      require('../translations/it-it.json'),
    );
    translationsProvider.translations(
      'es-es',
      require('../translations/es-es.json'),
    );

    $translateProvider.registerAvailableLanguageKeys(
      languageNames.map((language: ILanguageName) => language.code),
    );

    $translateProvider
      .preferredLanguage('nl-nl')
      .fallbackLanguage('en-gb')
      // sanitize output
      // TODO investigate why it's sometimes throws errors
      .useSanitizeValueStrategy('escaped');
  }

  static run(
    $anchorScroll: ng.IAnchorScrollService,
    $rootScope: ng.IRootScopeService,
    $templateCache: ng.ITemplateCacheService,
    $translate: ng.translate.ITranslateService,
    appName,
    isTest,
    language: Language,
    notificationManager: NotificationManager,
    session: Session,
    swServiceWorker: SwServiceWorker,
  ) {
    'ngInject';

    $translate.use(language.current);

    notificationManager.init();

    language.observe((languageId) => {
      $translate.use(languageId);
    });

    if (!isTest) {
      // Note! Bad code. Since SALES-234 sales inits itself, so does dashboard since SWDASH-267
      // logistics since LOG-65, and other apps should follow that soon
      if (
        appName !== 'dashboard' &&
        appName !== 'gate' &&
        appName !== 'logistics' &&
        appName !== 'picking' &&
        appName !== 'play' &&
        appName !== 'sales'
      ) {
        // There is nothing to be done if init is rejected, but we don't want
        // the unhandle rejection error
        session.init().catch(angular.noop);
      }

      swServiceWorker.startWorking();
    }

    $rootScope.$on('$routeChangeSuccess', () => {
      $anchorScroll();
    });

    $templateCache.put(
      '@core/app/views/uib-overrides/accordion-group.html',
      require('@core/app/views/uib-overrides/accordion-group.html').default,
    );

    $templateCache.put(
      '@core/app/views/uib-overrides/datepickerPopup.html',
      require('@core/app/views/uib-overrides/datepickerPopup.html').default,
    );
  }
}

require('./components/no-decorators');
require('./configs/no-decorators');
require('./controllers/no-decorators');
require('./directives/no-decorators');

/* eslint-disable angular/component-limit */
// TODO CORE-1042 refactor to service + constant
angular.module('coreModule').provider('translations', TranslationsProvider);
